import { useArticlesFilters } from 'collection/pages/articles/hooks/useArticlesFilters';
import { useDebounce } from 'lib-knowledge-delivery-common/hooks/useDebounce';
import { useEffect, useState } from 'react';

/**
 * A hook that provides a debounced search value and an `onChange` function that
 * updates the search value state. The search value is synchronized with the URL
 * search parameter, and can be used to filter a list of articles.
 */
export function useDebouncedSearchValueInUrl(): {
  instantSearchValue: string;
  onChange: (value: string) => void;
} {
  const {
    actions: { setSearchInput },
    store,
  } = useArticlesFilters();
  const [instantSearchValue, setInstantSearchValue] = useState<string>(
    store.search || '',
  );
  const debouncedSearchValue = useDebounce(instantSearchValue, 1000);

  useEffect(() => {
    setSearchInput(debouncedSearchValue);
  }, [setSearchInput, debouncedSearchValue]);

  function onChange(value: string) {
    setInstantSearchValue(value);
  }

  return { instantSearchValue, onChange };
}
